import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static targets = [];

  reload() {
    Turbo.clearCache();
    Turbo.visit(window.location.toString(), {
      action: 'replace',
    });
  }
}
